var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbeitsrecht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169.63 155.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.8,79.38c-2.51-3.28-11.41-11.7-25.91-13.67-23.04-3.13-39.16,11.13-44.26,16.68,0,0-3.09,3.47-6.74,9.48,0,0,0,0,0,0l-71.57.03c-5.92-.45-10.71-5.2-11.31-11.09V23.6c.42-6.02-2-11.06,11.3-11.31h49.87c.45-5.87.04-12.29,10.35-12.14,4.85-.02,10.18-.04,15.01-.15,12.05-.25,10.98,5.96,11.47,12.29h49.86c10.91.29,11.18,1.14,11.31,6.69.01.46,0,3.57,0,3.94l.62,56.46ZM81.41,55.16c-7.55.85-11.71,11.87-2.93,17.27,2.19,1.35,6.02,1.48,8.25.21,9.63-5.46,4.75-18.61-5.33-17.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.78,69.78l3.87.08c33.87,2.54,52.11,41.8,30.88,69.12-18.62,23.97-55.81,21.44-70.93-4.85-16.36-28.47,3.81-63.5,36.17-64.36ZM125.09,82.07c-23.78,1.29-37.3,28.41-23.5,48.12,12.98,18.54,40.99,17.09,51.91-2.72,11.58-20.99-4.6-46.7-28.41-45.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.4,93.99c3.78,2.1,8.02,3.28,12.42,3.49l68.18.24c-1.25,4.12-2.45,9.19-2.54,14.74s.81,7.85,2.89,15.69l-69.52.27c-5.13,0-11.44-6.14-11.44-10.99v-23.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.59,88.15c7.18-.05,5.95,2.45,6.23,5.65l.06,16.37,7.69,7.7c4.72,4.29,2.07,6.43-.34,8.6-2.27,2.05-3.77,4.82-8.51-.09-3.42-3.55-7.12-7.57-10.85-10.85l-.32-.49-.03-20.42c-.02-3.46-.77-6.41,6.07-6.46Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbeitsrecht);
export default __webpack_public_path__ + "static/media/Arbeitsrecht.594ea709524a0411d2484e93e31347fd.svg";
export { ForwardRef as ReactComponent };